export function getLOGOUT() {
  return process.env.POSTLOGOUTREDIRECTURI;
}

export function getPublicURL() {
    return process.env.PUBLIC_URL
}

export function getPasswordChange() {
  return process.env.CHANGEPASSWORD;
}

export const isDev = process.env.NODE_ENV === "development";
